import apiCallTemplate from "./config";
import credentials from "../assets/credentials";

const { BASE_URL } = credentials;
const makePayment = `${BASE_URL}/payment`;

//initialize payment
export const initPayment = async (initPaymentData) =>
  apiCallTemplate("post", `${makePayment}/initialize`, initPaymentData);

//verify payment
export const verifyPayment = async (query, data) =>
  apiCallTemplate("get", `${makePayment}/verify${query || ""}`);

//make transfer
export const paySeller = async (transferDetails, otp) =>
  apiCallTemplate("post", `${makePayment}/make-transfer`, transferDetails, otp);
